import { Inject, Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter, tap } from 'rxjs/operators';
import { GA_MEASUREMENT_ID, GTAG, Gtag } from './analytics.providers';

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {

    constructor(@Inject(GA_MEASUREMENT_ID) private id: string, @Inject(GTAG) private gtag: Gtag, private router: Router) { }

    trackPageViews() {
      if (!this.gtag) {
          throw 'gtag.js was not found! Are you missing the tracking code in the index.html header?';
      }

      if (!this.id) {
          throw 'Analytics cannot track page views because there is no provided GA_MEASUREMENT_ID';
      }

      this.router.events.pipe(
          filter(event => event instanceof NavigationEnd),
          tap(_event => this.pageView())
      )
      .subscribe();
    }

    private pageView() {
      this.gtag.pageView(this.id, { page_path: this.router.url });
    }

}
